module.exports = __webpack_public_path__ + "static/media/1.7a38bac8.jpg";